import PropTypes from "prop-types"
import { MediaPreview } from "ui/MediaPreview"
import { PreviewGallery } from "ui/PersonalInfo/ProfilePreview/PreviewGallery"
import styles from "./PhotoGrid.module.css"

export default function PhotoGrid({ photos = [], handleMediaClick, guideName = "", embedded = false }) {
  if (!photos.length) return null

  const renderMedia = (media, idx) => (
    <div key={media?.id || idx} className={styles.mediaWrapper}>
      {/* Blurred background layer */}
      <img src={media.url} alt="" className={styles.blurredBackground} />
      {/* Main media content */}
      <div className={styles.mediaContent}>
        <MediaPreview
          media={media}
          src={media.url}
          alt=""
          className="w-100 h-100"
          effect="blur"
          placeholderSrc={media.placeholder_url || null}
          onClick={() => handleMediaClick?.(media)}
        />
      </div>
    </div>
  )

  if (photos.length === 1) {
    return (
      <div className="grid gap-2 mt-15">
        <div className="g-col-12 g-col-lg-12">{renderMedia(photos[0], 0)}</div>
      </div>
    )
  }

  if (photos.length === 2) {
    return (
      <div className="grid gap-2 mt-15">
        {[0, 1].map((i) => (
          <div key={i} className="g-col-12 g-col-md-12 g-col-lg-6">
            {renderMedia(photos[i], i)}
          </div>
        ))}
      </div>
    )
  }

  // For 3+ photos: show 1 large photo on left
  return (
    <div className="grid gap-2 mt-15">
      <div className="g-col-12 g-col-lg-6" style={{maxHeight: 460}}>{renderMedia(photos[0], 0)}</div>
      <div
        className="g-col-12 g-col-lg-6 grid gap-2"
        style={{ maxHeight: 460, gridTemplateColumns: "1fr 1fr", gridTemplateRows: "1fr 1fr" }}
      >
        {[1, 2, 3, 4].map((photoIndex) => {
          const photo = photos[photoIndex]
          const isLastCell = photoIndex === 4

          // If photo doesn't exist, render empty space
          if (!photo) {
            return <div key={`empty-grid-${photoIndex}`} style={{ height: "100%" }} />
          }

          return (
            <div key={photo?.id || `grid-${photoIndex}`} className={isLastCell ? "position-relative" : ""} style={{ height: "100%" }}>
              {isLastCell && (
                <div className="position-absolute bottom-0 end-0 p-3 z-2">
                  <PreviewGallery name={guideName} mediaItems={photos} hideGrid />
                </div>
              )}
              {renderMedia(photo, photoIndex)}
            </div>
          )
        })}
      </div>
    </div>
  )
}

// ✅ PropTypes validation
PhotoGrid.propTypes = {
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      url: PropTypes.string.isRequired,
      placeholder_url: PropTypes.string
    })
  ),
  handleMediaClick: PropTypes.func,
  guideName: PropTypes.string,
  embedded: PropTypes.bool
}
